<template>
  <div class="left-menu box-s" :key="current_id" v-if="menus.length > 1">
    <div v-for="(item, index) in menus" :key="index">
      <div class="p16 fs14 menu-item" :class="{'menu-item-select': current_id == index}" @click="change_menu(index)" v-if="!item.hidden">
        <i :class="item.icon"></i>
        {{ item.name }}
      </div>
    </div>

    <!-- {{ menus }} -->

    <!-- {{ menus }} -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      current_id: 0,
      menus: []
    }
  },

  created() {
    this.updateMenus()
  },
  watch: {
    $route() {
      this.updateMenus()
    }
  },
  computed: {},
  methods: {
    updateMenus() {
      const pathParts = this.$route.path.split('/')
      const mainMenuPath = `/${pathParts[1]}`
      const subMenuPath = pathParts[2]
      this.setMenus(mainMenuPath, subMenuPath)
    },
    setMenus(mainMenuPath, subMenuPath) {
      const route = this.$router.options.routes.find(route => route.path === mainMenuPath)
      this.menus = route ? route.children : []
      this.current_id = this.menus.findIndex(item => item.path === subMenuPath)
    },
    change_menu(index) {
      this.current_id = index
      const path = this.$route.path
      const route_path = path.split('/')[1]
      const to_path = '/' + route_path + '/' + this.menus[index].path
      this.$router.push({
        path: to_path,
        query: {
          time: Date.now()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.left-menu {
  padding-top: 20px;
  height: calc(100vh - 85px);
}

.menu-item-select {
  font-weight: 600;
  color: #4073fa;
  background-color: #ecf1ff;
}

.menu-item {
  transition: background-color 0.3s;
  /* 平滑过渡效果 */
}

.menu-item:hover {
  background-color: #ecf1ff;
  /* 浅灰色背景 */
}
</style>
